import store from '@/store'
import { scopeEn,roleId, gender,payStatus,scope,level,region,paymentType,district,nation,areaCode,languages } from '@/biz/static-data'
export const mixin = {
  computed: {
    adminUserInfoRoleId() {
      return store.getters.adminUserInfo.roleId
    },
    sortBranchesList() {
      return this.sortBranches()
    }
  },
  data() {
    return {
      teacherRoleId:null,
      editorRoleId:null,
      siteAdminRoleId:null,
      genders:[],
      grades:[],
      levels:[],
      strands:[],
      languages:[],
      rolesName:[],
      areaCode:[],
      nation:[],
      district:[],
      payStatus:[],
      paymentType:[],
      region:[],
      scope:[],
      scopeEn:[],
      avatars:[],
      userInfoRoleRoleId: null,
      userInfoName: "",
      staffRoleName: "",
      userInfoId: "",
    }
  },
  created() {
    this.scope = scope
    this.scopeEn = scopeEn
    this.payStatus = payStatus
    this.teacherRoleId = roleId.teacher
    this.editorRoleId = roleId.editor
    this.siteAdminRoleId = roleId.siteAdmin
    this.levels = level
    this.district = district
    this.areaCode = areaCode
    this.region = region
    this.paymentType = paymentType
    this.genders = gender;
    this.nation = nation;
    this.languages = languages;
    if(store.getters.adminUserInfo !==null){
      this.userInfoRoleRoleId = store.getters.adminUserInfo.roleId
      this.initializeAvatars()
      if(this.sortBranchesList.length==0){
        store.dispatch("getBranchSchools");
      }
    }
  },
  methods: {
    initializeAvatars(){
      this.avatars = [
        `${process.env.VUE_APP_URL_API}/avatars/avatar_1.jpg`,
        `${process.env.VUE_APP_URL_API}/avatars/avatar_2.jpg`,
        `${process.env.VUE_APP_URL_API}/avatars/avatar_3.jpg`,
        `${process.env.VUE_APP_URL_API}/avatars/avatar_4.jpg`,
        `${process.env.VUE_APP_URL_API}/avatars/avatar_5.jpg`,
        `${process.env.VUE_APP_URL_API}/avatars/avatar_6.jpg`,
      ]
    },
    onBack() {
      this.$router.go(-1)
    },
    underline(value){
       return value.replace(/([A-Z])/g, (p, m) => `_${m.toLowerCase()}`)
    },
    resolveRouter(path){
      let newUrl = this.$router.resolve({
        path: path
      });
      window.open(newUrl.href, "_blank");
    },
    sortBranches() {
      // 检查是否存在 abbreviation 为 "HQ" 的对象
      const hqItem = store.getters.branchSchools.find(item => item.abbreviation === "HQ");
      // 过滤出非 "HQ" 的对象并按 abbreviation 字母排序
      const sortedBranches = store.getters.branchSchools
          .filter(item => item.abbreviation !== "HQ")
          .sort((a, b) => a.abbreviation.localeCompare(b.abbreviation));
      // 如果有 "HQ"，将其置顶
      if (hqItem) {
          sortedBranches.unshift(hqItem);
      }
      return sortedBranches;
    }
  }
}
